import { render } from "./CourseGroup.vue?vue&type=template&id=47ead032&scoped=true"
import script from "./CourseGroup.vue?vue&type=script&lang=js"
export * from "./CourseGroup.vue?vue&type=script&lang=js"

import "./CourseGroup.vue?vue&type=style&index=0&id=47ead032&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ead032"]])

export default __exports__